export default "__VITE_PUBLIC_ASSET__8176e1d2__"